import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'prgov-cadastre',
  templateUrl: './cadastre.component.html',
  styleUrls: ['./cadastre.component.scss'],
})
export class CadastreComponent implements OnInit {
  @Input() isAdmin = false;
  constructor() {}

  ngOnInit() {}
}
